import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_62: FaireProductEntity = {
  token: "legacy_prod_abbott-62",
  type: "product",
  name: "Gothica Lined Notebook 6×8 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/31d741987ee1ddfcceafcdcde46556cfb451a66f351afee358e25a22234bfb22.jpeg",
  priceDollars: 9,
  msrpDollars: 14,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
